import dataStore from '../../../store/dataStore.ts'
import React from 'react'
import { createPortal } from 'react-dom'
import { IPet } from '../../../interfaces/types.ts'
import historyStore from '../../../store/historyStore.ts'

interface Props {
    pet: IPet | null,
    onChange: (i: IPet | null) => void
    showNew?: boolean
}

export const PetSelectPopup = (props: Props, ) => {
    const { pet, onChange, showNew } = props
    const pets = dataStore(s => s.pets)
    const [open, setOpen] = React.useState(false)
    const selectedPetId = historyStore(s => s.selectedPetId)

    const newCard = (
        <div
            key={'new'}
            className={`btn h-auto btn-outline p-2 text-secondary bg-white`}
            onClick={() => {
                onChange(null)
                setOpen(false)
            }}
        >
            <div className={'flex items-center h-24'}>
                <div className={'text-lg'}>New Pet</div>
            </div>
        </div>
    )

const pop = (
    <div id={'modal'}
         className={'fixed z-[100000] left-0 top-0 w-[100vw] h-[100vh] overflow-auto bg-black/70 flex justify-center items-center'}
         data-theme={'gibi'}>
        <div className={'flex flex-col items-center'}>
            <div className={'text-3xl text-white pb-2'}>Select Pet</div>
            <div className={`grid grid-cols-3 gap-2 px-8`}>
                {pets.map(s => <div
                    key={s._id}
                    className={`btn h-auto btn-outline p-2 ${pet?._id === s._id ? 'text-white bg-secondary' : 'text-secondary bg-white'}`}
                    onClick={() => {
                        onChange(s)
                        setOpen(false)
                    }}
                >
                <div className={'flex flex-col items-center'}>
                            <div className="avatar">
                                <div className="w-24 rounded-full">
                                    <img src={s.imageURL}/>
                                </div>
                            </div>
                            <div className={'text-lg'}>{s.petName}</div>
                        </div>
                    </div>)}
                {showNew ? newCard : null}
            </div>

            <div className={'p-6'} onClick={() => setOpen(false)}>
                    <button className={'btn btn-secondary'}>Cancel</button>
                </div>
            </div>
        </div>
    )

    const displayValue = /*showNew ? (
        <div className={'h-8 text-base-content border-solid border border-primary/50 rounded w-full px-2 focus-visible:outline-0 text-xl bg-white'}
             onClick={() => setOpen(true)}
        >
            {pet?.petName || 'New pet'}
        </div>
    ) :*/ (
        <div
            onClick={() => setOpen(true)}
        >
            <button className={`btn btn-secondary btn-outline bg-white btn-md without-ring text-xl text-wrap border-[4px] w-[7rem] h-[5rem] ${selectedPetId ? '!p-0 !bg-base-100' : 'pt-2'}`}>
                {!selectedPetId ? 'Choose Pet' :
                    <div className="object-cover bg-base-secondary">
                        <img className="object-cover w-[76px] rounded" style={{height: 'calc(5rem - 8px)'}} src={pets.find(p => p._id === selectedPetId)?.imageURL}/>
                    </div>
                }
            </button>
        </div>
    )

    return open ? createPortal(pop, document.body) : displayValue
}
